import dayjs from 'dayjs';
import api from '~/api';
import { PageResponse } from '../../../../_shared/data/dto/PageResponse';
import { Page } from '../../../../_shared/data/models/Page';
import { ReferralResponse, ReferralStatusResponse } from '../dtos/referralResponse';
import { Referral, type ReferralStatus } from '../models/referrals.model';

const StatusMap: Record<ReferralStatusResponse, ReferralStatus> = {
  draft: 'Referred',
  pending_acceptance: 'Pending Acceptance',
  pending_compliance: 'Pending Compliance',
  compliance_block: 'Compliance Block',
  pending_csm_assignment: 'Pending Assignment',
  pending_onboarding: 'Account Setup',
  pending_first_run: 'Pending First Payroll Run',
  missing_information: 'Missing Information',
};

export async function getActiveReferrals(
  partnerId: string,
  { page, search }: { page: number; search: string }
): Promise<Page<Referral>> {
  const { data } = await api.get<PageResponse<ReferralResponse>>(
    `v2/partner/${partnerId}/customers?status=active&page=${page}&search=${search}&ordered_by=created&ordered_type=desc`
  );

  const referrals = data.result.map(
    (referral) =>
      new Referral(
        referral.business_name,
        dayjs(referral.first_payroll_run_date),
        StatusMap[referral.onboarding_status]
      )
  );

  return {
    items: referrals,
    search: '',
    totalItems: data.total_count,
    current: page,
  };
}
